import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { AddressLayout } from "../common/Layouts";
let transportCarrier = null;
function AddressTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    transportCarrier = props.formFields.R_TRANSPORTCARRIER;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = () => {
    }
    const handleFieldValueChange = (e) => {
    }
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div className="FormMt">
            <FormField
            currrentUser={currentUser}
            layoutId='F799F9E9-CD8C-453C-AB75-A21FBE91ABEF'
            layoutName='AddressForm'
            defaultFormSchema={AddressLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            onFormLoad={onFormLoad}
            handleFieldValueChange={handleFieldValueChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
            noSpacingBeforeFirstRow={true}
        />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AddressTab);